module.exports = __webpack_public_path__ + "img/vip2.fc4d7952.png";